import React from 'react';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Slide,
  Stack,
  Typography,
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { Props } from './types';
import styles from './slideUpDialog.module.scss';
import { CircularLoader } from '../../Loader';
import Button from '../../FormControl/Button';
import Icon from 'components/FormControl/Icon';

const Transition: Record<
  string,
  React.ForwardRefExoticComponent<
    TransitionProps & { children: React.ReactElement } & React.RefAttributes<unknown>
  >
> = {
  up: React.forwardRef(function Transition(
    props: TransitionProps & {
      children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
  ) {
    return <Slide direction='up' ref={ref} {...props} />;
  }),
  left: React.forwardRef(function Transition(
    props: TransitionProps & {
      children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
  ) {
    return <Slide direction='left' ref={ref} {...props} />;
  }),
};
const SlideUpDialog: React.FC<Props> = (props) => {
  const { direction = 'up' } = props;
  return (
    <Dialog open={props.open} onClose={props.onClose} TransitionComponent={Transition[direction]}>
      <DialogContent className={`${styles[`slide${direction}Container`]} ${styles.container}`}>
        <DialogTitle className={styles.title}>
          <Stack direction='row' justifyContent='space-between' alignItems='center'>
            <Box>
              <Typography variant='h4'>{props.title}</Typography>
              {props.subtitle ? (
                <Typography variant='body2' className={styles.subTitle}>
                  {props.subtitle}
                </Typography>
              ) : null}
            </Box>
            <Box>
              {props.actionText && props.onAction ? (
                <Button
                  text={props.actionText}
                  className={
                    props.actionDisable
                      ? styles.disableAction
                      : `${props.actionType && styles[props.actionType]}`
                  }
                  size='small'
                  variant='text'
                  disabled={props.actionDisable}
                  onClick={props.onAction}
                  enableLoading={props.actionLoading}
                />
              ) : null}
              <IconButton className={styles.closeAction} onClick={props.onClose}>
                <Icon icon={'ri-close-line'} size='1.3rem' />
              </IconButton>
            </Box>
          </Stack>
        </DialogTitle>
        <div className={`${props.containerClass} ${styles.contentContainer}`}>
          {props.children}
          {props.loading ? (
            <div className={styles.loadingOverlay}>
              <CircularLoader />
            </div>
          ) : null}
        </div>
        {props.footer && (
          <DialogActions className={`${styles.actionsContainer} ${props.footerClass || ''}`}>
            {props.footer}
          </DialogActions>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SlideUpDialog;
